/* =========================================================
   Plantive Contact Page - JS (Typewriter, Swapper & Lazy Reveal)
========================================================= */

document.addEventListener('DOMContentLoaded', () => {
  
  // 1. ⌨️ Typewriter Effect Logic (รองรับสระภาษาไทย & เคอร์เซอร์วิ่งตามหลังคำ)
  const headingGroups = document.querySelectorAll('.plc-heading-group');
  
  headingGroups.forEach(group => {
    const heading = group.querySelector('.plc-heading');
    
    if (heading) {
      // ดึงข้อความมาเก็บไว้ก่อน
      group.dataset.originalText = heading.textContent.trim();
      // สร้างโครงสร้างใหม่: กล่องข้อความที่ถูกพิมพ์ + เคอร์เซอร์
      heading.innerHTML = '<span class="plc-typing-text"></span><span class="plc-typing-cursor">|</span>';
    }
  });

  // 2. 🔄 Split Master Swapper (รูปเด้ง, ชื่อสไลด์เข้า)
  const cardAvatars = document.querySelectorAll('.plc-swap-avatar');
  const cardNames = document.querySelectorAll('.plc-swap-name');
  
  if (cardAvatars.length > 0) cardAvatars[0].classList.add('is-active');
  if (cardNames.length > 0) cardNames[0].classList.add('is-active');

  if (cardAvatars.length > 1) {
    let currentIndex = 0;
    setInterval(() => {
      if(cardAvatars[currentIndex]) cardAvatars[currentIndex].classList.remove('is-active');
      if(cardNames[currentIndex]) cardNames[currentIndex].classList.remove('is-active');
      
      currentIndex = (currentIndex + 1) % cardAvatars.length;
      
      if(cardAvatars[currentIndex]) cardAvatars[currentIndex].classList.add('is-active');
      if(cardNames[currentIndex]) cardNames[currentIndex].classList.add('is-active');
    }, 3500); 
  }

  // 3. ❓ FAQ Accordion Logic
  const faqHeaders = document.querySelectorAll('.js-plc-faq-header');
  faqHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const item = this.closest('.plc-faq-item');
      const content = item.querySelector('.plc-faq-content');
      const isActive = item.classList.contains('is-active');

      document.querySelectorAll('.plc-faq-item').forEach(el => {
        el.classList.remove('is-active');
        el.querySelector('.plc-faq-content').style.maxHeight = null;
      });

      if (!isActive) {
        item.classList.add('is-active');
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  });

  window.addEventListener('resize', () => {
    document.querySelectorAll('.plc-faq-item.is-active').forEach(item => {
      const content = item.querySelector('.plc-faq-content');
      content.style.maxHeight = content.scrollHeight + "px";
    });
  });

  // 4. 👀 Reveal Animation on Scroll (Lazy Animation ทีละชิ้น)
  const observeElements = document.querySelectorAll('.js-plc-observe');
  
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        requestAnimationFrame(() => {
          entry.target.classList.add('is-visible');
          
          // ตรวจสอบว่าถ้าเป็น Heading Group ให้สั่งทำงานพิมพ์ดีด
          if (entry.target.classList.contains('plc-heading-group')) {
            // ป้องกันการพิมพ์ซ้ำซ้อน
            if (entry.target.dataset.typed) return;
            entry.target.dataset.typed = 'true';

            const group = entry.target;
            const headingText = group.querySelector('.plc-typing-text');
            const cursor = group.querySelector('.plc-typing-cursor');
            const subheading = group.querySelector('.plc-subheading');
            
            const speedMs = parseInt(group.dataset.typingSpeed) || 40;
            const text = group.dataset.originalText || '';

            // ตัดคำภาษาไทย (กันสระแตกบรรทัด)
            let textArray = [];
            if (window.Intl && Intl.Segmenter) {
              const segmenter = new Intl.Segmenter('th', { granularity: 'grapheme' });
              textArray = Array.from(segmenter.segment(text)).map(s => s.segment);
            } else {
              textArray = text.match(/[\u0E00-\u0E7F][\u0E31\u0E34-\u0E3A\u0E47-\u0E4E]*|./g) || text.split('');
            }

            let i = 0;
            
            // สั่งซ่อน subheading ไว้ก่อน
            if (subheading) {
              subheading.style.opacity = '0';
            }

            if (textArray.length > 0) {
              // 💡 ยิงข้อความใส่ทีละตัว ตัวอักษรจะดันให้กรอบกว้างออก และ Cursor จะวิ่งตามหลังแบบสมจริง
              const typeInterval = setInterval(() => {
                if (headingText) headingText.textContent += textArray[i];
                i++;
                if (i >= textArray.length) {
                  clearInterval(typeInterval);
                  
                  // โชว์ Subheading โผล่ขึ้นมานุ่มๆ
                  if (subheading) {
                    subheading.classList.add('is-visible');
                  }
                  // ปิด Cursor หลังจากพิมพ์จบสักพัก
                  setTimeout(() => { if (cursor) cursor.style.opacity = '0'; }, 2500);
                }
              }, speedMs);
            } else {
               if (subheading) subheading.classList.add('is-visible');
               if (cursor) cursor.style.opacity = '0';
            }
          }
        });
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 }); 

  observeElements.forEach(el => observer.observe(el));
});